module.exports = __webpack_public_path__ + "images/emoji/toilet.6cebcd8fe05710743c4f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/toilet.png
// module id = o4kf
// module chunks = 24